// src/components/GerarQrCodeMesa.js
import React, { useState } from 'react';
import { QRCodeCanvas } from 'qrcode.react';
import QRCode from 'qrcode';

const GerarQrCodeMesaComponent = () => {
  const [numeroMesa, setNumeroMesa] = useState('');
  const [qrValue, setQrValue] = useState('');

  const handleGerarQrCode = () => {
    if (!numeroMesa) {
      alert("Informe o número da mesa");
      return;
    }
    // o qrcode abaixo é para quando o usuário já tiver feito checkin
    const url = `${window.location.origin}/atualizar-checkin-qrcodemesa/${numeroMesa}`;
    // o qrcode abaixo é para quando o usuário ainda não tiver feito checkin
    // const url = `http://localhost:3000/fazer-checkin-qrcodemesa/${numeroMesa}`;
    setQrValue(url);
  };

  const handleDownloadQRCode = async () => {
    if (!qrValue) {
      alert("Gere o QR Code primeiro");
      return;
    }
  
    try {
      const size = 256;
      const padding = 60;
      const fontSize = 45;
      const text = `Mesa ${numeroMesa}`;
  
      // Cria um canvas apenas para o QR
      const qrCanvas = document.createElement('canvas');
      await QRCode.toCanvas(qrCanvas, qrValue, { width: size, margin: 1 });
  
      // Agora cria o canvas final com espaço para texto
      const finalCanvas = document.createElement('canvas');
      finalCanvas.width = size;
      finalCanvas.height = size + padding;
      const ctx = finalCanvas.getContext('2d');
  
      // Fundo branco
      ctx.fillStyle = 'white';
      ctx.fillRect(0, 0, finalCanvas.width, finalCanvas.height);
  
      // Desenha o QR Code gerado
      ctx.drawImage(qrCanvas, 0, 0);
  
      // Texto abaixo do QR
      ctx.font = `${fontSize}px Arial`;
      ctx.fillStyle = 'black';
      ctx.textAlign = 'center';
      ctx.fillText(text, finalCanvas.width / 2, size + fontSize + 10);
  
      // Converte e baixa
      const dataUrl = finalCanvas.toDataURL('image/png');
      const link = document.createElement('a');
      link.href = dataUrl;
      link.download = `mesa-${numeroMesa}.png`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Erro ao gerar imagem para download:", error);
    }
  };
  

  return (
    <div style={{ maxWidth: 400, margin: '2rem auto', textAlign: 'center', fontFamily: 'Arial, sans-serif' }}>
      <h2>Gerar QR Code da Mesa</h2>

      <input
        type="number"
        min="1"
        placeholder="Número da mesa"
        value={numeroMesa}
        onChange={(e) => {
          setNumeroMesa(e.target.value);
          setQrValue('');
        }}
        style={{ padding: '0.5rem', fontSize: '1rem', width: '100%', boxSizing: 'border-box' }}
      />

      <button
        onClick={handleGerarQrCode}
        style={{
          marginTop: '1rem',
          padding: '0.5rem 1rem',
          fontSize: '1rem',
          cursor: 'pointer',
          width: '100%',
          backgroundColor: '#007bff',
          color: 'white',
          border: 'none',
          borderRadius: 4,
        }}
      >
        Gerar QR Code
      </button>

      {qrValue && (
        <div style={{ marginTop: '2rem' }}>
          <p><strong>QR Code para mesa {numeroMesa}:</strong></p>
          <QRCodeCanvas value={qrValue} size={256} />
          <button
            onClick={handleDownloadQRCode}
            style={{
              marginTop: '1rem',
              padding: '0.5rem 1rem',
              fontSize: '1rem',
              cursor: 'pointer',
              backgroundColor: '#28a745',
              color: 'white',
              border: 'none',
              borderRadius: 4,
            }}
          >
            Baixar QR Code
          </button>
          {/* <p style={{ marginTop: '1rem', fontSize: '0.9rem', wordBreak: 'break-word' }}>{qrValue}</p> */}
        </div>
      )}
    </div>
  );
};

export default GerarQrCodeMesaComponent;
